// src/api/geocodeUtils.ts
import { type GeocodedAddress } from '../shared/types';
export type { GeocodedAddress };

export async function geocodeAddress(address: string): Promise<GeocodedAddress> {
  console.log('geocodeAddress: Starting geocoding for:', address);

  if (!window.google?.maps?.Geocoder) {
    console.error('geocodeAddress: Google Maps Geocoder not initialized!');
    throw new Error('Google Maps not loaded properly');
  }

  const geocoder = new google.maps.Geocoder();
  console.log('geocodeAddress: Geocoder created');

  try {
    console.log('geocodeAddress: Calling geocode API...');
    const result = await new Promise<google.maps.GeocoderResult>((resolve, reject) => {
      geocoder.geocode({ address }, (results, status) => {
        console.log('Geocoder response status:', status);
        if (status === 'OK' && results && results[0]) {
          resolve(results[0]);
        } else {
          reject(new Error(`Geocoding failed with status: ${status}`));
        }
      });
    });
    console.log('geocodeAddress: Got result:', result);

    const location = result.geometry.location;
    const addressComponents = result.address_components;
    console.log('geocodeAddress: Parsed components:', { location, addressComponents });

    const streetNumber = addressComponents.find(c => 
      c.types.includes('street_number'))?.long_name || '';
    const street = addressComponents.find(c => 
      c.types.includes('route'))?.long_name || '';

    return {
      lat: location.lat(),
      lng: location.lng(),
      streetNumber,
      street,
    };
  } catch (error) {
    console.error('Geocoding error:', error);
    throw new Error('Failed to geocode address');
  }
}